import { render, staticRenderFns } from "./updates.vue?vue&type=template&id=6bfadd1c&scoped=true&"
import script from "./updates.vue?vue&type=script&lang=js&"
export * from "./updates.vue?vue&type=script&lang=js&"
import style0 from "./updates.vue?vue&type=style&index=0&id=6bfadd1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfadd1c",
  null
  
)

export default component.exports